<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <!-- <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon> -->
            {{ $t('phone_verification') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-img src="@/assets/images/svg/phone_verification.svg" />
        <div class="mt-8 text-center">
          <div class="title font-weight-bold">
            {{ $t('verify_your_phone_number') }}
          </div>
          <div class="mt-4" v-html="$t('we_will_call_please_check', { phone: data_verification.value.phone })" />
        </div>
        <div class="mt-4">
          <div :class="[`d-flex justify-center align-center`, { 'phone-error': hasError }]">
            <div class="sec-phone">
              <div class="">
                +62 999 - 9999 -
              </div>
            </div>
            <div class="ml-3">
              <CodeInput :loading="false" :fields="4" :auto-focus="true" :field-width="50" :field-height="50" class="input inputVerificationCode" @change="onChangeOtp" @complete="onCompleteOtp" />
              <div v-if="hasError" class="phone-has-error">
                {{ $t('number_is_invalid') }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <div class="__menu-bottom menu-full menu-full-flat">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <div :class="[`mb-3`, { 'd-flex justify-space-between': formattedTimeLeft === 'EXPIRED' }]">
            <div v-if="formattedTimeLeft === 'EXPIRED'" class="font-weight-bold primary--text cursor-pointer" @click="recallOtp(2)">
              {{ $t('recall') }}
            </div>
            <div v-if="formattedTimeLeft !== 'EXPIRED'" class="text-center" v-html="$t('recall_available_in', { time: formattedTimeLeft })" />
            <div v-if="formattedTimeLeft === 'EXPIRED'" class="font-weight-bold primary--text cursor-pointer" @click="recallOtp(1)">
              {{ $t('use_sms_instead') }}
            </div>
          </div>
          <v-btn type="submit" :disabled="disabled_verify" color="primary" block x-large class="text-none" @click="verifyNow()">
            {{ $t('verify') }}
          </v-btn>
        </v-col>
      </div>
    </v-row>
    <!-- <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="py-12 px-2 text-center">
          <img v-if="type_verification === 'email'" src="@/assets/images/svg/mail.svg" alt="mail" class="img-mail-verification">
          <img v-else src="@/assets/images/svg/phone.svg" alt="phone" class="img-mail-verification">
          <h4 class="title font-weight-bold my-5">
            Input Verification Code
          </h4>
          <h5 v-if="type_verification === 'email'" class="subtitle-1 grey--text">
            Verification code has been sent to email
          </h5>
          <h5 v-else class="subtitle-1 grey--text">
            Verification code has been sent to phone
          </h5>
          <h5 v-if="type_verification === 'email'" class="subtitle-1 grey--text font-weight-bold">
            {{ form.email }}
          </h5>
          <h5 v-else class="subtitle-1 grey--text font-weight-bold">
            {{ form.phone }}
          </h5>
          <div class="d-flex __col-verification">
            <div class="mx-1">
              <v-text-field ref="one" v-model="code.one" class="input-verification" maxlength="1" />
            </div>
            <div class="mx-1">
              <v-text-field ref="two" v-model="code.two" class="input-verification" maxlength="1" />
            </div>
            <div class="mx-1">
              <v-text-field ref="three" v-model="code.three" class="input-verification" maxlength="1" />
            </div>
            <div class="mx-1">
              <v-text-field ref="four" v-model="code.four" class="input-verification" maxlength="1" />
            </div>
            <div class="mx-1">
              <v-text-field ref="five" v-model="code.five" class="input-verification" maxlength="1" />
            </div>
          </div>
          <div class="mt-12">
            <v-btn color="primary" x-large block class="text-none" @click="verify()">
              Konfirmasi
            </v-btn>
            <div class="mt-5 text-center">
              <a class="grey--text text-non-direction" @click="resendCode()">Kirim ulang code?</a>
            </div>
          </div>
        </div>
      </v-col>
    </v-row> -->

    <v-snackbar v-model="dataSuccess.show" multi-line top color="success" :timeout="3000">
      {{ dataSuccess.message }}
      <v-btn class="transparent" text fab x-small dark @click="closeDataSuccess()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  validOtp as validOtpCustomer,
  forgotPass as forgotPassCustomer
} from '@/api/auth'
export default {
  data() {
    return {
      dataSuccess: {
        show: false,
        message: ''
      },
      type_verification: 'email',
      data_verification: {},
      timerInterval: null,
      distance: 0,
      form: {
        phone: '',
        email: '',
        otp_code: ''
      },
      disabled_verify: false,
      hasError: false
    }
  },
  computed: {
    formattedTimeLeft() {
      let minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.distance % (1000 * 60)) / 1000)
      let result
      if (this.distance < 0) {
        result = 'EXPIRED'
      } else {
        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = minutes + ':' + seconds
      }
      return result
    }
  },
  watch: {
    formattedTimeLeft: function(newItem, oldItem) {
      if (newItem === 'EXPIRED' || newItem === null) {
        this.disabled_verify = true
      }
    }
  },
  created() {
    this.data_verification = this.$store.state.data_verification
    this.getExpiryTime(new Date(this.data_verification.value.expiry_otp))
  },
  methods: {
    closeDataSuccess() {
      this.dataSuccess.show = false
    },
    onChangeOtp(v) {
      this.hasError = false
    },
    onCompleteOtp(v) {
      this.hasError = false
      this.form.otp_code = v
      this.disabled_verify = false
    },
    async verifyNow() {
      try {
        this.form.phone = this.data_verification.value.phone
        const { data } = await validOtpCustomer(this.form)
        this.$store.state.loading_axios = false
        this.dataSuccess.show = true
        this.dataSuccess.message = data.message
        this.$store.dispatch('set_otp_forget_password', this.form.otp_code)
        this.$router.push({ name: 'new_password' }).catch(() => {})
      } catch (e) {
        this.hasError = true
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async recallOtp(otp_type = 2) {
      try {
        let obj = {}
        if (otp_type !== 3) {
          obj = {
            otp_type: otp_type,
            phone: this.data_verification.value.phone
          }
        } else {
          obj = {
            otp_type: otp_type,
            email: this.data_verification.value.email
          }
        }
        await forgotPassCustomer(obj)
        const data_verify = this.data_verification
        data_verify.value.expiry_otp = new Date(new Date().getTime() + 2 * 60000)
        this.$store.dispatch('data_verification', data_verify)
        this.$store.state.loading_axios = false
        if (otp_type === 1) {
          this.$router.push({ name: 'forget_verification_otp_sms', query: { redirect: this.$route.query.redirect }}).catch(() => {})
        }
        this.disabled_verify = false
        this.getExpiryTime(new Date(this.data_verification.value.expiry_otp))
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time.getTime())
      const _this = this
      this.timerInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.distance = countDownDate - now
        if (_this.distance < 0) {
          clearInterval(_this.timerInterval)
        }
      }, 1000)
    }
  }
}
</script>
